// extracted by mini-css-extract-plugin
export default {"root":"R2lgF4","picture":"pz1Nvh","hidden":"kE1ply","content":"F8iMQV","overlayHeader":"vDI1VP","title":"mW1ZAG","buttons":"B2YUVp"};